import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DownloadImageryComponent } from "./download-imagery.component";
import { ToastService } from "../../services/internal-services/toast.service";
import { ViewerConstants } from "../../../shared/model/viewer-constants";
import { MapService } from "../../services/internal-services/map.service";
import { GoogleAnalyticsService } from "../../../shared/services/google-analytics.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-phoenix-download-imagery",
  templateUrl: "./download-imagery.component.html",
  styleUrls: ["./download-imagery.component.scss"],
  standalone: false,
})
export class PhoenixDownloadImageryComponent extends DownloadImageryComponent {
  private _mode: any;

  @Input() set mode(mode: any) {
    this._mode = mode;
    this.showToolbar = mode ? mode.name === ViewerConstants.COLLECTION_MODES.OBLIQUE.name : false;
  }

  get mode(): any {
    return this._mode;
  }

  constructor(
    googleAnalyticsService: GoogleAnalyticsService,
    dialog: MatDialog,
    toastService: ToastService,
    mapService: MapService,
  ) {
    super(googleAnalyticsService, dialog, toastService, mapService);
  }
}
